<template>
  <l-marker :lat-lng="marker.position" :icon="marker.icon" @click="openPopup">
    <l-tooltip :content="marker.tooltip" />
    <l-popup :options="{maxWidth: 200, maxHeight: 200}" ref="popup">
      <div v-if="opened">
        <p v-for="victim in marker.victims" :key="victim.id">
          <a :href="victim.url">{{ victim.fullName }}</a><br>
          {{ victim.streetAddress }}<br>
          Baltimore, MD<br>
          Race: {{ victim.race }}<br>
          Gender: {{ victim.gender }}<br>
          <template v-if="victim.age !== null">
            Age: {{ victim.age }} year{{ victim.age|pluralize }} old<br>
          </template>
          <template v-if="victim.cause !== 'unknown'">
            Cause of death: {{ victim.causeVerbose }}<br>
          </template>
          Victim found on {{ victim.dateFoundVerbose }}<br>
          <template v-if="victim.deathLocation !== 'unknown'">
            Victim died at {{ victim.deathLocationVerbose }}<br>
          </template>
          <template v-if="victim.notes">
            <div v-html="victim.notes"></div>
          </template>
          <a :href="victim.url">More</a>
        </p>
      </div>
    </l-popup>
  </l-marker>
</template>

<script>
import { LMarker, LPopup, LTooltip } from "vue2-leaflet";

export default {
  name: "VictimMarker",
  components: {
    LMarker,
    LPopup,
    LTooltip
  },
  data() {
    // `opened` is an attempted performance hack to try to
    // lazy load creation of the popup contents when it
    // is needed for rendering.
    return { opened: false };
  },
  props: {
    marker: Object
  },
  computed: {},
  filters: {
    pluralize(arr) {
      return arr.length === 1 ? "" : "s";
    }
  },
  methods: {
    openPopup() {
      this.opened = true;
      // Need to resize the popup box after it contains content
      this.$nextTick(() => {
        this.$refs.popup.mapObject.update();
      });
    }
  }
};
</script>
